<template>
    <v-app>
        <main
            class="main-container"
            :class="{ 'no-padding': this.$route.meta.isNotPadding, 'no-margin': this.$route.meta.isNotMargin }"
        >
            <router-view />
        </main>
        <Notications />
        <DialogComponent />
        <Navigation v-if="this.$route.meta.isShowMenu" />
    </v-app>
</template>
<script>
import Navigation from "@/components/navigation/index.vue";
import Notications from "@/components/common/notications/index.vue";
import DialogComponent from "@/components/common/dialog/index.vue";
import EventBus from "./utils/EventBus";

import { version } from "../package.json";

import {
    compareVersions,
    getParamQueryTheme,
    isStrEmpty,
    setSettingDevice,
} from "./utils/utils";

export default {
    components: {
        Notications,
        DialogComponent,
        Navigation,
    },
    mounted() {
        this.fetchData();
        if (!isStrEmpty(getParamQueryTheme("userid"))) {
            localStorage.setItem("userid", getParamQueryTheme("userid"));
        }
        document.addEventListener("message", this.handleMessage);
    },
    beforeDestroy() {
        document.removeEventListener("message", this.handleMessage);
    },
    methods: {
        fetchData() {
            const cart = !isStrEmpty(localStorage.getItem("cart"))
                ? JSON.parse(localStorage.getItem("cart"))
                : [];
            const cartRender = !isStrEmpty(localStorage.getItem("cartRender"))
                ? JSON.parse(localStorage.getItem("cartRender"))
                : [];
            const quantity = !isStrEmpty(localStorage.getItem("quantity"))
                ? localStorage.getItem("quantity")
                : 0;
            const totalCart = !isStrEmpty(localStorage.getItem("totalCart"))
                ? localStorage.getItem("totalCart")
                : 0;
            const transact = !isStrEmpty(localStorage.getItem("transact"))
                ? JSON.parse(localStorage.getItem("transact"))
                : [];
            const transactPariLotto = !isStrEmpty(
                localStorage.getItem("transactPariLotto")
            )
                ? JSON.parse(localStorage.getItem("transactPariLotto"))
                : [];
            const stepCart = !isStrEmpty(localStorage.getItem("stepCart"))
                ? JSON.parse(localStorage.getItem("stepCart"))
                : 1;
            this.$store.state.cart = cart;
            this.$store.state.cartRender = cartRender || [];
            this.$store.state.transact = transact;
            this.$store.state.transactPariLotto = transactPariLotto;
            this.$store.state.quantity = parseInt(quantity);
            this.$store.state.totalCart = parseInt(totalCart);
            this.$store.state.stepCart = parseInt(stepCart);
        },
        handleMessage(event) {
            const resp = JSON.parse(event.data);
            if (resp.command === "go-back") {
                if (this.$route.name.toLowerCase() === "home page") {
                    parent.postMessage({ command: "on-confirm-out-app" }, "*");
                } else if (this.$route.name.toLowerCase() === "loto") {
                    EventBus.$emit("on-handle-back-app");
                } else {
                    this.$router.go(-1);
                }
            }
            if (resp.command === "device-info") {
                const data = resp.data;
                setSettingDevice(data);
                let versionApp = compareVersions(data.appVersion, version);
                this.$store.state.versionApp = versionApp;
            }
        },
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/main.scss";
</style>
